import { useMutation } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export interface BuildRelativityParentRelationshipsResponse {
  newRelationshipsCreated: number;
  existingRelationshipsSkipped: number;
  relationships: Array<{
    childControlNumber: string;
    parentControlNumber: string;
    status: 'created' | 'already_exists';
  }>;
}

interface BuildRelativityParentRelationshipsParams {
  matterId: string;
  workspaceId: number;
}

const useBuildRelativityParentRelationships = () => {
  const { getFetchConfig } = useGetFetchConfig();

  const buildRelationships = async ({
    matterId,
    workspaceId,
  }: BuildRelativityParentRelationshipsParams): Promise<BuildRelativityParentRelationshipsResponse> => {
    const url = `${APIBaseChronos}/api/relativity/sync/relationships?matterId=${matterId}&workspaceId=${workspaceId}`;
    const response = await fetch(url, getFetchConfig({ method: FetchMethod.POST }));

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `Failed to build relationships: ${response.status} ${response.statusText}`);
    }

    return response.json();
  };

  return useMutation(buildRelationships);
};

export default useBuildRelativityParentRelationships;
